<kt-base-modal [title]="'Select Break'">
  <div modal-body>
    <div class="row">
      <div class="col-12">
        <div class="h5 text-center bg-light p-3 mb-3">
          Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
        </div>
      </div>
      <div class="col-lg-6 form-group">
        <google-map *ngIf="mapReady() && location.latitude" class="kt-map d-block w-100" width="100%" height="400px"
          [center]="{ lat: location.latitude, lng: location.longitude }" [zoom]="18" [options]="{ streetViewControl: false }">
          <map-marker #m1="mapMarker" [position]="{ lat: location.latitude, lng: location.longitude }"
            [options]="{ draggable: false, icon: defaultEnum.LOCATION_ICON_URL, title: 'My Current Location' }"
            (mapClick)="openInfoWindow(m1, 'My Current Location')">
          </map-marker>
          <map-marker #m2="mapMarker" *ngIf="shiftDetails"
            [position]="{ lat: (+shiftDetails.area.area_latitude), lng: (+shiftDetails.area.area_longitude) }"
            [options]="{ draggable: false }"
            (mapClick)="openInfoWindow(m2, (shiftDetails?.area?.area_name || '') + ' ' + (shiftDetails?.area?.area_address || ''))">
          </map-marker>
          <map-info-window>{{ infoContent }}</map-info-window>
        </google-map>

      </div>

      <div class="col-lg-6">
        <form [formGroup]="breakFormGroup">
          <div class="text-center m-2 h5"> Select Break</div>
          <div class="kt-widget4">

            <ng-container *ngFor="let break of breaks">
              <label class="kt-option form-group p-3">
                <span class="kt-option__control">
                  <span class="kt-radio kt-radio--brand" *ngIf="!break.disabled">
                    <input type="radio" formControlName="break" [value]="break" [disabled]="break.disabled">
                    <span></span>
                  </span>
                </span>

                <span class="kt-option__label">
                  <span class="kt-option__head">
                    <span class="kt-option__title">
                      {{break.shift_break_type}} Break
                    </span>
                  </span>
                  <span class="kt-option__body pt-0">
                    Duration: {{break.shift_break_total_time}} Min
                    <span *ngIf="break?.shift_break_fix_time_enable">
                      <br>
                      {{(break?.shift_break_start_date) | TimezoneDateTime }}
                      <b> - </b>
                      {{break?.shift_break_end_date | TimezoneDateTime }}
                    </span>
                  </span>
                </span>

              </label>
            </ng-container>
          </div>
        </form>

      </div>

    </div>

    <div class="modal-footer justify-content-between">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
      </kt-button>
      <kt-button *ngIf="isSaveButtonDisplay" [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG"
        (buttonClick)="startBreakHandler()">
      </kt-button>

    </div>
  </div>
</kt-base-modal>